// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_pages_module_ts":"11a4b18dca12c8ea","src_app_pages_booking_booking_module_ts":"9d791417b2846ac6","node_modules_dompurify_dist_purify_js":"3347441a96af75c5","node_modules_canvg_lib_index_es_js":"e37181a1e691a721"}[chunkId] + ".js";
};